"use client";

import { isEcommercePreviewReadOnly } from "@/config/preview-mode";

export function PreviewReadOnlyNotice() {
  if (!isEcommercePreviewReadOnly()) {
    return null;
  }

  return (
    <aside
      className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-sm font-semibold text-amber-950"
      role="status"
    >
      Vista previa de solo lectura: los pedidos y el seguimiento están deshabilitados.
    </aside>
  );
}
